import { render, staticRenderFns } from "./AdvancedFormItem.vue?vue&type=template&id=efec4402"
import script from "./AdvancedFormItem.vue?vue&type=script&lang=js"
export * from "./AdvancedFormItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports